import axios from "axios";
import { CATEGORY_URL } from "../../../../utils/constService";
import { getAuthHeader } from "../../../../../configuration/Utils/constService";

export const fetchCategory = (params = {}) => {
  return axios.get(CATEGORY_URL, { ...getAuthHeader(), params });
};
export const fetchCategoryForFilter = () => {
  return axios.get(`${CATEGORY_URL}/get-all`, getAuthHeader());
};
export const postCategory = (data) => {
  return axios.post(CATEGORY_URL, data, getAuthHeader());
};

export const putCategory = (data, categoryId) => {
  return axios.put(`${CATEGORY_URL}/${categoryId}`, data, getAuthHeader());
};

export const deleteCategory = (categoryId) => {
  return axios.delete(`${CATEGORY_URL}/${categoryId}`, getAuthHeader());
};
